module.exports = __webpack_public_path__ + "img/logo-3.4b8253cb.png";